<template>
  <div ref="simulator" class="api-simulator pb4">
    <header class="text-centered">
      <svg class="w2" style="vertical-align: text-bottom" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><path fill="none" d="M.5.5h18v18H.5z"/><path d="M9.5 15.5l7-7-2-5h-10l-2 5 7 7z" fill="#FF7D79"/></svg> Ruby API Tutorial
    </header>
    <transition-group tag="div" v-on:before-enter="beforeEnter">
      <div v-for="(step, index) in steps" v-bind:key="index + ''" class="section">
        <div class="pv2 ph3">
          <template v-for="element in step">
            <br v-if="element.type == 'break'">
            <span v-if="element.type == 'text'">{{ element.content }}</span>
            <pre v-if="element.type == 'result'" class="result text-monospace">{{ element.content }}</pre>
            <code v-if="element.type == 'code'">{{ element.content }}</code>
            <pre v-if="element.type == 'pre'" v-html="syntaxHighlight(element.content)"></pre>
            <span v-if="element.type == 'emoji'" class="emoji">{{ element.content }}</span>
            <div v-if="element.type == 'show'" class="text-right mb3">
              <button v-on:click="showFullCode()">{{ element.content }}</button>
            </div>
            <div v-if="element.type == 'button'" class="pv2 text-right">
              <div v-if="thinking && index + 1 == currentStep" class="pr3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="42" height="42" fill="white"><circle transform="translate(8 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle><circle transform="translate(16 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.3" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle><circle transform="translate(24 0)" cx="0" cy="16" r="0"><animate attributeName="r" values="0; 4; 0; 0" dur="1.2s" repeatCount="indefinite" begin="0.6" keytimes="0;0.2;0.7;1" keySplines="0.2 0.2 0.4 0.8;0.2 0.6 0.4 0.8;0.2 0.6 0.4 0.8" calcMode="spline" /></circle></svg>
              </div>
              <div v-else-if="index < currentStep" class="icon-check"></div>
              <div v-else>
                <span class="text-subtle mr2">{{ progress() }}</span>
                <button v-on:click="nextStep()">{{ element.content }}</button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition-group>
    <div v-if="fullCodeIsVisible" class="pa3">
<pre><template v-for="element in fullCode">
<span v-if="element.type == 'break'"></span><code v-if="element.type == 'result'" class="hi-result">{{ element.content }}</code><code v-if="element.type == 'comment'" class="hi-comment">{{ element.content }}</code><code v-if="element.type == 'code'" v-html="syntaxHighlight(element.content)"></code></template></pre>
    </div>
  </div>
</template>

<script>
import { Tutorial } from './ruby-tutorial-steps';
import { Code } from './ruby-tutorial-code';
import syntaxHighlight from '../../javascript/common/syntax-highlight';

export default {
  mounted () {
    this.steps.push(Tutorial[0]);
    this.currentStep = 0;
  },
  data () {
    return {
      steps: [],
      totalSteps: 0,
      currentStep: 0,
      thinking: false,
      fullCodeIsVisible: false,
      fullCode: ''
    };
  },
  methods: {
    nextStep (number) {
      this.currentStep++;
      this.steps.push(Tutorial[this.currentStep]);
    },
    beforeEnter (el) {
      this.thinking = true;
      el.style.visibility = 'hidden';
      setTimeout(() => {
        this.thinking = false;
        el.style.visibility = 'visible';
        this.scrollWindow();
      }, 1000);
    },
    scrollWindow () {
      const windowMaxHeight = 500; // This is defined with max-height in CSS
      setTimeout(() => {
        this.$refs.simulator.scrollTop = this.$refs.simulator.scrollTop + 10;
        if (this.$refs.simulator.scrollTop < this.$refs.simulator.scrollHeight - windowMaxHeight)
          this.scrollWindow();
      }, 10);
    },
    syntaxHighlight,
    progress () {
      return `Step ${this.currentStep + 1} of ${Tutorial.length}`;
    },
    showFullCode () {
      this.fullCodeIsVisible = true;
      this.fullCode = Code;
      this.scrollWindow();
    }
  }
};
</script>
